import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { firebaseConfig } from './services/firebase';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    const swUrl = `/firebase-messaging-sw.js?apiKey=${firebaseConfig.apiKey}&projectId=${firebaseConfig.projectId}&messagingSenderId=${firebaseConfig.messagingSenderId}&appId=${firebaseConfig.appId}`;
    navigator.serviceWorker.register(swUrl).then((registration) => {
      console.log('ServiceWorker PWA registrado com sucesso: ', registration.scope);
    }).catch((error) => {
      console.log('Falha ao registrar ServiceWorker PWA: ', error);
    });
  });
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);